import { EmptyState } from '@backstage/core-components';
import { EntitySwitch } from '@backstage/plugin-catalog';
import {
  EntityTechdocsContent,
  isTechDocsAvailable,
} from '@backstage/plugin-techdocs';

export const technicalDocumentationContent = (
  <EntitySwitch>
    <EntitySwitch.Case if={isTechDocsAvailable}>
      <EntityTechdocsContent />
    </EntitySwitch.Case>
    <EntitySwitch.Case>
      <EmptyState
        title="No documentation"
        description="Add the backstage.io/techdocs-ref annotation to enable docs."
        missing="info"
      />
    </EntitySwitch.Case>
  </EntitySwitch>
);
